export interface ParsedUnifiedSkillSearch {
	search?: string;
	vertical?: string;
	functionName?: string;
	tagsAll: string[];
	tagsNone: string[];
}

function normalizeTokenValue(value: string): string {
	return value.trim().replace(/^"|"$/g, '');
}

export function parseUnifiedSkillSearch(input: string): ParsedUnifiedSkillSearch {
	const tokens = input
		.trim()
		.split(/\s+/)
		.filter(Boolean);

	let vertical: string | undefined;
	let functionName: string | undefined;
	const tagsAll: string[] = [];
	const tagsNone: string[] = [];
	const text: string[] = [];

	for (const token of tokens) {
		const lower = token.toLowerCase();

		if (lower.startsWith('vertical:') || lower.startsWith('v:')) {
			const raw = token.includes(':') ? token.split(':').slice(1).join(':') : '';
			const value = normalizeTokenValue(raw);
			if (value) vertical = value;
			continue;
		}

		if (lower.startsWith('function:') || lower.startsWith('f:')) {
			const raw = token.includes(':') ? token.split(':').slice(1).join(':') : '';
			const value = normalizeTokenValue(raw);
			if (value) functionName = value;
			continue;
		}

		if (lower.startsWith('tag:')) {
			const value = normalizeTokenValue(token.slice(4));
			if (value) tagsAll.push(value);
			continue;
		}

		if (lower.startsWith('-tag:')) {
			const value = normalizeTokenValue(token.slice(5));
			if (value) tagsNone.push(value);
			continue;
		}

		text.push(token);
	}

	return {
		search: text.length ? text.join(' ') : undefined,
		vertical,
		functionName,
		tagsAll: Array.from(new Set(tagsAll)),
		tagsNone: Array.from(new Set(tagsNone)),
	};
}
